import HealthSituationUsage from '@/modules/health/hiring/models/APP/HealthSituationUsage'
import HealthSituationDescription from '@/modules/health/hiring/models/APP/HealthSituationDescription'

export default class HealthHiringInsuredHealthSituation {
  private _cardiac!: HealthSituationDescription
  private _metabolic!: HealthSituationDescription
  private _rheumatic!: HealthSituationDescription
  private _nervous!: HealthSituationDescription
  private _hematologic!: HealthSituationDescription
  private _urogenital!: HealthSituationDescription
  private _psychiatric!: HealthSituationDescription
  private _infectious!: HealthSituationDescription
  private _medication!: HealthSituationDescription
  private _alcohol!: HealthSituationUsage
  private _smoking!: HealthSituationUsage
  private _drugs!: HealthSituationDescription
  private _injuries!: HealthSituationDescription
  private _disability!: HealthSituationDescription

  filled: boolean | null

  constructor(data: Partial<HealthHiringInsuredHealthSituation> = {}) {
    this.cardiac = data.cardiac
    this.metabolic = data.metabolic
    this.rheumatic = data.rheumatic
    this.nervous = data.nervous
    this.hematologic = data.hematologic
    this.urogenital = data.urogenital
    this.psychiatric = data.psychiatric
    this.infectious = data.infectious
    this.medication = data.medication
    this.alcohol = data.alcohol
    this.smoking = data.smoking
    this.drugs = data.drugs
    this.injuries = data.injuries
    this.disability = data.disability

    this.filled = data.filled ?? null
  }

  get cardiac(): HealthSituationDescription {
    return this._cardiac
  }

  set cardiac(value: HealthSituationDescription | undefined) {
    this._cardiac = new HealthSituationDescription(value?.description)
  }

  get metabolic(): HealthSituationDescription {
    return this._metabolic
  }

  set metabolic(value: HealthSituationDescription | undefined) {
    this._metabolic = new HealthSituationDescription(value?.description)
  }

  get rheumatic(): HealthSituationDescription {
    return this._rheumatic
  }

  set rheumatic(value: HealthSituationDescription | undefined) {
    this._rheumatic = new HealthSituationDescription(value?.description)
  }

  get nervous(): HealthSituationDescription {
    return this._nervous
  }

  set nervous(value: HealthSituationDescription | undefined) {
    this._nervous = new HealthSituationDescription(value?.description)
  }

  get hematologic(): HealthSituationDescription {
    return this._hematologic
  }

  set hematologic(value: HealthSituationDescription | undefined) {
    this._hematologic = new HealthSituationDescription(value?.description)
  }

  get urogenital(): HealthSituationDescription {
    return this._urogenital
  }

  set urogenital(value: HealthSituationDescription | undefined) {
    this._urogenital = new HealthSituationDescription(value?.description)
  }

  get psychiatric(): HealthSituationDescription {
    return this._psychiatric
  }

  set psychiatric(value: HealthSituationDescription | undefined) {
    this._psychiatric = new HealthSituationDescription(value?.description)
  }

  get infectious(): HealthSituationDescription {
    return this._infectious
  }

  set infectious(value: HealthSituationDescription | undefined) {
    this._infectious = new HealthSituationDescription(value?.description)
  }

  get medication(): HealthSituationDescription {
    return this._medication
  }

  set medication(value: HealthSituationDescription | undefined) {
    this._medication = new HealthSituationDescription(value?.description)
  }

  get alcohol(): HealthSituationUsage {
    return this._alcohol
  }

  set alcohol(value: HealthSituationUsage | undefined) {
    this._alcohol = new HealthSituationUsage(value?.type, value?.frequency)
  }

  get smoking(): HealthSituationUsage {
    return this._smoking
  }

  set smoking(value: HealthSituationUsage | undefined) {
    this._smoking = new HealthSituationUsage(value?.type, value?.frequency)
  }

  get drugs(): HealthSituationDescription {
    return this._drugs
  }

  set drugs(value: HealthSituationDescription | undefined) {
    this._drugs = new HealthSituationDescription(value?.description)
  }

  get injuries(): HealthSituationDescription {
    return this._injuries
  }

  set injuries(value: HealthSituationDescription | undefined) {
    this._injuries = new HealthSituationDescription(value?.description)
  }

  get disability(): HealthSituationDescription {
    return this._disability
  }

  set disability(value: HealthSituationDescription | undefined) {
    this._disability = new HealthSituationDescription(value?.description)
  }

  isEmpty() {
    return !this.filled
  }

  updateAttributes(newAttributes: Partial<HealthHiringInsuredHealthSituation>) {
    Object.assign(this, newAttributes)
  }
}
